import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    locale:localStorage.getItem('lang') || 'zh'
  },
  mutations: {
    setLanguage(state, value){
      state.locale = value
      localStorage.setItem('lang', value)
    }
  },
  actions: {
   
  },
  getters :{
    getLanguage: state => state.locale,
  },
  modules: {}
})

export default store